import type { BlsEdge } from "./blsMotion";

/** Long enough to feel through a grip, short enough to stay a tap. */
export const TACTILE_PULSE_MS = 120;

/** Which controller to buzz, and how hard each of its motors. */
export type RumbleTarget = {
    /** 0 for the left hand, 1 for the right, among the controllers in use. */
    slot: 0 | 1;
    strongMagnitude: number;
    weakMagnitude: number;
};

/**
 * The pulse for one edge, given how many controllers the patient holds.
 *
 * Two controllers are one per hand, and the whole controller buzzes. A single
 * controller is held in both hands: a standard pad has its heavy motor in the
 * left grip and its light one in the right, so alternating the motors is felt
 * as left and right — less sharply than two pads, but still bilateral.
 */
export function tactilePulse(edge: BlsEdge, controllers: number): RumbleTarget | null {
    if (controllers <= 0) return null;
    if (controllers >= 2) {
        return { slot: edge === "left" ? 0 : 1, strongMagnitude: 1, weakMagnitude: 1 };
    }
    return edge === "left"
        ? { slot: 0, strongMagnitude: 1, weakMagnitude: 0 }
        : { slot: 0, strongMagnitude: 0, weakMagnitude: 1 };
}
